import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'

// One-time catalog seed so a freshly provisioned database isn't empty on
// first load. Guarded server-side (server/routes/index.ts /api/dev/seed) —
// it's a no-op once the collections table has any row, so this is safe to
// fire on every page load.
void fetch('/api/dev/seed', { method: 'POST' }).catch(() => undefined)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
